import React, { Component } from 'react';
import { connect } from 'react-redux';
import VehicleDetails from './VehicleDetails';
import ContainerDetails from './ContainerDetails';
import StopDetails from './StopDetails';
import BiddingAndPayments from './BiddingAndPayments';
import CostHeadDetails from './costHeadDetails';
import Trip from 'Models/Trip';
import {
    TAT_UNITS,
    AVG_DISTANCE
} from 'Constants/commonConstants';
import {
    GET_MASTER_ROUTE_CODE_DETAILS,
    GET_LPP_DETAILS,
    TOAST_ERROR
} from 'Constants/actionConstants';
import { getUser } from 'Utils/storage';
class AddTrip extends Component {
    constructor(props) {
        super(props);
        const trip = props.trip || new Trip();
        this.viewMode = props.viewMode;
       
        if(!props.trip) {
            trip.addStop();
            trip.addStop();
            trip.addLeg();
            trip.biddingDetails.setTatUnit(TAT_UNITS[0]);
        }
        this.state = {
            trip: trip,
            lppDetails: {},
            routeMasterDetails: []
        }
        this.viewMode = props.viewMode;
    }

    onChange = (type)=> {
        this.setState({
            trip: this.state.trip,
            isChangelegValue: type === 'isChange' ? true : false
        }, () => {
            const { trip } = this.state;
            if(type === 'stop' && trip.stops.length > 1 && trip.stops[0].location && trip.stops[1].location) {
                this.getLPPDetails();
            }
        })
    }

    getLPPDetails = () => {
        const { dispatch, rfq } = this.props;
        const { trip } = this.state;
        const user = getUser();
        const multiple_routes = [];
        if((trip.stops || []).length > 2 && !(trip.stops || []).find(stop => !stop.location)) {
            multiple_routes.push({
                source: trip.stops[0].location,
                destination: trip.stops[2].location
            });
            (trip.stops || []).forEach((val, index) => {
                if(index > 1 && index < trip.stops.length-1) {
                    multiple_routes.push({
                        source: val.location,
                        destination: trip.stops[index + 1].location
                    })
                } else if(trip.stops.length -1 === index) {
                    multiple_routes.push({
                        source: val.location,
                        destination: trip.stops[1].location
                    })
                }
            })
        }
        const multi_route = {
            multiple_routes: multiple_routes.length > 0 && multiple_routes || undefined,
            multiple_source: multiple_routes.length > 0 && (multiple_routes || []).map(mRoute => mRoute.source).join(' ') || undefined,
            multiple_destination: multiple_routes.length > 0 && (multiple_routes || []).map(mRoute => mRoute.destination).join(' ') || undefined
        }
        dispatch({
            type: GET_LPP_DETAILS,
            data: {
                rfqType: {
                        companyId: (user && user.companyId) ? user.companyId : null,
                        source: trip.stops[0].location,
                        destination: trip.stops[1].location,
                        vehicle_type: trip.vehicleTypeName,
                        vehicle_Body: trip.vehicleBodyTypeName,
                        ...multi_route,
                        pricing_basis: rfq.biddingDetails.pricingBasis,
                        rfq_type: rfq.type
                    }
            },
            onSuccess: ((data)=> {
                this.setState({
                    tripRouteCode:data.rfqType.route_code ? data.rfqType.route_code : null,
                    lppDetails: {
                        ...data.rfqType,
                        ...multi_route
                    }
                });
            })
        })
    }

    getMasterRouteCodeDetails = (from, to) => {
        const { dispatch } = this.props;
        dispatch({
           type: GET_MASTER_ROUTE_CODE_DETAILS,
           params: {
              limit: 20,
              offset: 0,
              from,
              to
           },
           onSuccess: (data) => {
            if(data) {
                this.setState({
                   routeMasterDetails: data
                });
            }
           }
        });
    }

    saveAndClose = ()=> {
        const { trip } = this.state;
        const { 
            rfqServiceType, 
            rfqType, 
            addTrip
        } = this.props;
        // if([13,14,15].includes(rfqType)) {
        //     this.props.closeTrip();
        //     return;
        // }
        if(![15,13,14].includes(rfqType) && (!trip.vehicleBodyType || !trip.vehicleType || !trip.stops[0].location || !trip.stops[1].location || !(trip.biddingDetails || {}).diesel_price || !trip.routeCode)) {
            this.setState({
                isError: true
            });
            this.getErrorMessage();
            return;
        } else if([15,13,14].includes(rfqType) && (!trip.vehicleBodyType || !trip.vehicleType || !(trip.legs[0].from || {}).location || !(trip.legs[0].to || {}).location || !trip.priceInBaseCurrencyType)) {
            this.setState({
                isError: true
            });
            this.getErrorMessage();
            return;
        } else {
            const apiData = this.state.trip.getApiData(rfqType, rfqServiceType);
            apiData.route_code = this.state.tripRouteCode ? this.state.tripRouteCode : (apiData.route_code || null);
            apiData.distance = this.state.trip.distance;
            apiData.distance_uom = this.state.trip.distance_uom;
            apiData.lpp=this.state.lppDetails.lpp || (apiData.bidding_and_payments || {}).lpp;
            apiData.lpp_previous_date = this.state.lppDetails ? this.state.lppDetails.lpp_date_time : undefined;
            apiData.lpp_previous_vehicle_type = this.state.lppDetails ? this.state.lppDetails.lpp_vehicle_type : undefined;
            apiData.is_km_inserted_by = this.state.lppDetails ? this.state.lppDetails.is_km_inserted_by : null;
            apiData.multiple_destination = this.state.lppDetails ? this.state.lppDetails.multiple_destination : null;
            apiData.multiple_routes = this.state.lppDetails ? this.state.lppDetails.multiple_routes : null;
            apiData.multiple_source = this.state.lppDetails ? this.state.lppDetails.multiple_source : null;
            apiData.multiple_route_distance = this.state.lppDetails ? this.state.lppDetails.multiple_route_distance : null
            addTrip(apiData, false);
        }
    }


    saveAndKeepAdding = ()=> {
        const { trip } = this.state;
        const { rfqServiceType, rfqType, addTrip, rfq } = this.props;
        // if([13,14,15].includes(rfqType)) {
        //     this.props.closeTrip();
        //     return;
        // }
        if(![15,13,14].includes(rfqType) && (!trip.vehicleBodyType || !trip.vehicleType || !trip.stops[0].location || !trip.stops[1].location || !(trip.biddingDetails || {}).diesel_price || !trip.routeCode)) {
            this.setState({
                isError: true
            });
            this.getErrorMessage();
            return;
        } else if([15,13,14].includes(rfqType) && (!trip.vehicleBodyType || !trip.vehicleType || !(trip.legs[0].from || {}).location || !(trip.legs[0].to || {}).location || !trip.priceInBaseCurrencyType)) {
            this.setState({
                isError: true
            });
            this.getErrorMessage();
            return;
        }
        const apiData = this.state.trip.getApiData(rfqType, rfqServiceType);
        apiData.route_code = this.state.tripRouteCode ? this.state.tripRouteCode : (apiData.route_code || null);
        apiData.distance = trip.distance;
        apiData.distance_uom = trip.distance_uom;
        apiData.lpp=this.state.lppDetails.lpp;
        apiData.lpp_previous_date = this.state.lppDetails ? this.state.lppDetails.lpp_date_time : undefined;
        apiData.lpp_previous_vehicle_type = this.state.lppDetails ? this.state.lppDetails.lpp_vehicle_type : undefined;
        apiData.is_km_inserted_by= this.state.lppDetails ? this.state.lppDetails.is_km_inserted_by: null;
        apiData.multiple_destination = this.state.lppDetails ? this.state.lppDetails.multiple_destination : null;
        apiData.multiple_routes = this.state.lppDetails ? this.state.lppDetails.multiple_routes : null;
        apiData.multiple_source = this.state.lppDetails ? this.state.lppDetails.multiple_source : null;
        apiData.multiple_route_distance = this.state.lppDetails ? this.state.lppDetails.multiple_route_distance : null;
        addTrip(apiData, true);
       
    }

    getErrorMessage = () => {
        const { dispatch } = this.props;
        dispatch({
            type: TOAST_ERROR,
            message: 'Please enter all the mandatory details'
        });
    }

    render() {
        const { 
            addTrip,
            vehicleTypes,
            vehicleBodyTypes,
            autoSuggestLocations,
            businessVolumes,
            rfqType,
            rfq,
            costHeadList,
            currencyDetails,
            currencyTypes,
            portsList
        } = this.props;
        const { trip, routeMasterDetails, isError, isChangelegValue } = this.state;
        
        return( 
            <div className='tStart'>
               {rfqType === 12 && 
                <>
                    <VehicleDetails 
                        vehicleTypes={vehicleTypes}
                        vehicleBodyTypes={vehicleBodyTypes}
                        trip={trip}
                        onChange={this.onChange}
                        viewMode = {this.viewMode}
                        isError={isError}
                    />
                    <StopDetails 
                        trip = {trip} 
                        onChange={this.onChange}
                        viewMode = {this.viewMode}
                        // showError = { showError }
                        // submitted={stopDetailsSubmitted}
                        autoSuggestLocations={autoSuggestLocations}
                        masterRouteCodeDetails={routeMasterDetails}
                        getMasterRouteCodeDetails={this.getMasterRouteCodeDetails}
                        isError={isError}
                    />
                    <BiddingAndPayments 
                        type={'addTrip'}
                        biddingDetails = {trip.biddingDetails} 
                        onChange={this.onChange}
                        businessVolumes={businessVolumes}
                        viewMode = {this.viewMode}
                        lppDetails={this.state.lppDetails}
                        viewType="trip"
                        isError={isError}
                    />
                </>}
                {
                    [13, 14, 15].includes(rfqType) && 
                    <>
                        <ContainerDetails
                            vehicleTypes={vehicleTypes}
                            vehicleBodyTypes={vehicleBodyTypes}
                            trip={trip}
                            onChange={this.onChange}
                            viewMode = {this.viewMode}
                            rfq={rfq}
                            isError={isError}
                        />
                        <CostHeadDetails
                            trip={trip}
                            onChange={this.onChange}
                            businessVolumes={businessVolumes}
                            viewMode={this.viewMode}
                            rfqType={rfqType}
                            currencyDetails={currencyDetails}
                            // stopDetailsSubmitted={stopDetailsSubmitted}
                            currencyTypes={currencyTypes}
                            rfqServiceType={rfq.rfqDetails.serviceType}
                            // baseCurrencySubmitted = {baseCurrencySubmitted}
                            rfq={rfq}
                            costHeadList={costHeadList}
                            portsList={portsList}
                            isError={isError}
                            isChangelegValue={isChangelegValue}
                            multiLevelMovementType={rfq.rfqDetails.multiLevelMovementType}
                        />
                        </>
                }
                
                <div className="flex flex-middle mt-20 fRight mb-20">
                    <button className="fbutton next" onClick={this.props.closeTrip}> Close </button>
                    <div className=" mr-30 curP fbutton" onClick={this.saveAndClose}>
                        <span className="pl-10 fbutton previous fs-16" >Save & Close </span>
                    </div>
                    <button className="fbutton next" onClick={this.saveAndKeepAdding}> Save & Keep Adding </button>
                </div>
                
            </div>
        )
    }
}

export default connect(null, null)(AddTrip);